<template>
  <v-dialog v-model="dialog" width="1500px" fullscreen scrollable>
    <v-card>
      <v-card-title class="mx-3">
        {{ $t('StockOrderOUT.PickingOut.confirm') }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>

      <v-row class="ml-6 mr-6">
        <v-col cols="4" v-if="search.datetimeRadioSelected == 'created'">
          {{ $t("StockOrderOUT.Fields.created_time") }}
          {{ $t("Global.colon") }}
          {{ search.created_time_from }} / {{ search.created_time_to }}
        </v-col>
        <v-col cols="4" v-else>
          {{ $t("StockOrderOUT.Fields.actual_time") }}
          {{ $t("Global.colon") }}
          {{ search.actual_time_from }} / {{ search.actual_time_to }}
        </v-col>
        <v-col cols="4">
         {{ $t("StockOrderOUT.Fields.stock_name") }}
          {{ $t("Global.colon") }}
          {{ searchData.stockName }}
        </v-col>
        <v-col cols="4">
          {{ $t("DistributionUser.title") }}
          {{ $t("Global.colon") }}
          {{ searchData.distribution }}
        </v-col>
      </v-row>

      <v-row dense align="center" class="ml-6 mr-6">
        <!-- 商品分类 -->
        <v-col cols="12" sm="6" md="4">
          <v-select
                  v-model="pickingMaterialCategories"
                  :items="materialCategoryList"
                  item-value="key"
                  item-text="value"
                  :label="$t('MaterialCategory.title')"
                  clearable
          ></v-select>
        </v-col>
        <!-- 商品 -->
        <v-col cols="12" sm="6" md="4">
          <v-select
                  v-model="material"
                  :items="materialsList"
                  item-value="key"
                  item-text="value"
                  :label="$t('Material.title')"
                  clearable
          ></v-select>
        </v-col>
        <!-- 分拣状态 -->
        <v-col cols="12" sm="6" md="4">
          <SearcherStatus
                  v-model="pickingOutOptions.material_sorting_status"
                  :label="$t('StockOrderOUT.PickingOut.status')"
                  :items="$consts.stock_out_order.sorting_status"
          />
        </v-col>
      </v-row>

      <v-row class="ma-0">
        <v-col cols="6" md="0">
          <v-data-table
                  ref="material_table"
                  :headers="headers"
                  :items="materials"
                  :loading="loading"
                  :options.sync="pickingOutOptions"
                  :page.sync="paging.page"
                  :server-items-length="paging.count"
                  multi-sort
                  class="elevation-0 px-6 material_table"
                  fixed-header
                  :height="getTableHeight"
                  @click.native="clickEvent"
                  @click:row="setStockOrders($event)"
                  :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.material_name="{ item }" >
              {{ item.material_name }}
              <br />
              <span style="font-size: 12px">{{ item.material_code }}
                <span v-if="item.standard_name">/{{ item.standard_name }}</span>
              </span>
            </template>
            <template v-slot:item.sorting_percent="{ item }">
              <v-chip
                      small
                      label
                      :color="(item.complete_sorting_flg == 1) ? 'primary' : 'danger'"
                      :text-color="'white'"
              >
                {{ item.sorting_percent }}%
              </v-chip>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="6" md="0">
          <v-data-table
                  :headers="stockHeaders"
                  :items="stockOrders"
                  :loading="loading"
                  multi-sort
                  class="elevation-0 px-6"
                  fixed-header
                  :height="getTableHeight"
                  :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.current_count="{ item }">
              <span>
                {{ item.current_count }}{{ item.stock_unit }}
              </span>
            </template>
            <template v-slot:item.confirm_num="{ item }">
              <span>
                {{ item.confirm_num }}{{ item.stock_unit }}
              </span>
            </template>
            <template v-slot:item.sorting_num="{ item }">
              <span>
                {{ item.sorting_num }}{{ item.stock_unit }}
              </span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="(materials.length > 0) ? false : true"
          @click.stop="doSubmit()"
        >
          {{ $t("StockOrderOUT.PickingOut.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import StockOuts from "@/api/stock_outs";
import SearcherStatus from "@/components/plugins/SearcherStatus";


export default {
  name: "DialogPickingOut",

  components: {
    SearcherStatus
  },

  props: {
    value: Boolean,
    search: Object,
    searchData: Array
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.categories_name"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.materials_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.total_num"),
          align: "start",
          sortable: false,
          value: "default_num_total"
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.total_sorting"),
          align: "start",
          sortable: false,
          value: "sorting_num_total"
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.sorting_percent"),
          align: "start",
          sortable: true,
          value: "sorting_percent"
        },
      ];
    },
    stockHeaders() {
      return [
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.shop_name"),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.stock_order_code"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.current_count"),
          align: "start",
          sortable: false,
          value: "current_count",
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.confirm_num"),
          align: "start",
          sortable: false,
          value: "confirm_num",
        },
        {
          text: i18n.t("StockOrderOUT.PickingOut.Fields.sorting_num"),
          align: "start",
          sortable: false,
          value: "sorting_num",
        },
      ];
    },
    getTableHeight() {
      return parseFloat(window.innerHeight * 0.7).toFixed(0)
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    materials: [],
    stockOrders: [],
    pickingOutOptions: {},
    paging: {},
    materialCategoryList: [],
    materialsList: [],
    pickingMaterialCategories: null,
    material: null,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          this.pickingOutOptions = this.search
          // 每次打开对话框重置查询
          this.getMaterialsFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.paging = {};
          this.pickingOutOptions = this.search
          this.materials = [];
          this.stockOrders = [];
          this.materialCategoryList = [];
          this.materialsList = [];
          this.pickingMaterialCategories = null;
          this.material = null;
        }
      },
    },
    pickingOutOptions: {
      deep: true,
      handler() {
        if (this.pickingOutOptions != {}) {
          this.getMaterialsFromAPI();
          this.resetClick()
        }
      }
    },
    pickingMaterialCategories: {
      handler() {
        this.pickingOutOptions.category_codes = []
        if (!this.pickingMaterialCategories) {
          this.pickingOutOptions.category_codes = this.search.category_codes
        }else {
          this.pickingOutOptions.category_codes.push(this.pickingMaterialCategories);
        }
      }
    },
    material: {
      handler() {
        this.pickingOutOptions.material_ids = []
        if (!this.material) {
          this.pickingOutOptions.material_ids = this.search.material_ids
        }else {
          this.pickingOutOptions.material_ids = []
          this.pickingOutOptions.material_ids.push(this.material);
        }
      }
    }
  },

  methods: {
    getMaterialsFromAPI() {
      StockOuts.getWeightPickAndSorting(this.pickingOutOptions).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.materials
            this.materials.forEach((material, index) => {
              material.key = index;
            })
            this.materialCategoryList = response.data.material_category_list
            this.materialsList = response.data.materials_list
          }
        }.bind(this)
      );
      this.$nextTick(function(){
        this.resetClick(true)
      }.bind(this))

    },
    doSubmit() {
      this.pickingOutOptions.prat_sorting_out_mode = "";
      if ( this.pickingOutOptions.datetimeRadioSelected && this.pickingOutOptions.datetimeRadioSelected == 'actual') {
        this.pickingOutOptions.actual_date_from = this.pickingOutOptions.actual_time_from
        this.pickingOutOptions.actual_date_to = this.pickingOutOptions.actual_time_to
      }
      StockOuts.batchSortingOut(this.pickingOutOptions).then(
              function (response) {
                if (response.data.status.isOK()) {
                  if (response.data.part_sorting_details.length == 0){
                    this.$snackbar.success(i18n.t("StockOrderOUT.Messages.pickingOutSuccess"));
                    this.$emit("pickingOut", this.dialog);
                  }else {
                    this.$emit("confirm", {
                      details: response.data.part_sorting_details,
                      options: this.pickingOutOptions
                    });
                  }
                }
              }.bind(this))
    },
    setStockOrders(materialsSelected){
      this.stockOrders = []
      this.stockOrders = materialsSelected.stock_orders
    },
    clickEvent(event) {
      if (event.target.tagName == 'TD') {
        this.resetClick()
        event.target.parentElement.className = 'v-data-table__selected';
      }
    },
    resetClick(isDefault = false) {
      if (isDefault ) {
        let trList = document.getElementsByTagName('table')[1].children[2].children;
        trList[0].className = "v-data-table__selected";
        return;
      }
      let trList = document.getElementsByTagName('table')[1].children[2].children;
      for (let i = 0; i < trList.length; i++){
        trList[i].className="";
      }
    }
  },
};
</script>
